import { Link } from 'react-router-dom'
import { getUser } from '../../../../utils'

import * as S from './styles'

type HeaderLinksProps = {
  routes: string[]
  children?: React.ReactNode
}

const HeaderLinks = ({ routes, children }: HeaderLinksProps) => {
  const user = getUser()

  return (
    <S.HeaderContainer>
      <S.LinksContainer>
        <Link
          to={routes[0]}
          className={
            window.location.pathname === `${routes[0]}` ? 'active' : ''
          }
        >
          Meus dados
        </Link>
        <Link
          to={routes[1]}
          className={
            window.location.pathname === `${routes[1]}` ? 'active' : ''
          }
        >
          Alterar senha
        </Link>
        {user.usuario.roles[0].cdRole === 1 && (
          <Link
            to={routes[2]}
            className={
              window.location.pathname === `${routes[2]}` ? 'active' : ''
            }
          >
            Meu faturamento
          </Link>
        )}
      </S.LinksContainer>
      {children}
    </S.HeaderContainer>
  )
}
export default HeaderLinks
